/// <reference path='../_all.ts' />



module library {

  export class LanguageVariant {
    constructor(
      public DocumentFileSrcID : number, 
      public Language : string, 
      public Revisions : Revision[]
    ) { }
  }

  export class Revision {
    constructor(
      public DocumentFileSrcRevID : number, 
      public DocumentFileSrcRevName : string, 
      public Level : number,
      public ReleaseDate : Date,
      public FileType : FileType[]
    ) { }
  }

  export class FileType {
    constructor(
      public DocumentRevDestID : number, 
      public FileTypeDesc : string, 
      public DocumentRev : DocumentRev
    ) { }
  }


  export interface ILibraryDetailCtrlScope extends ng.IScope {
    vm : LibraryDetailCtrl;
    meta : navigation.IPageMetaServiceFunction;

    error : boolean;
        
    settings : {
      view: string;
    };

    data : DocumentDetailServiceData;
    requestOnGoing : boolean;
    revIdMissing : boolean;
  }

}